import { render } from "./SubcategoryForm.vue?vue&type=template&id=a6655238&scoped=true"
import script from "./SubcategoryForm.vue?vue&type=script&lang=js"
export * from "./SubcategoryForm.vue?vue&type=script&lang=js"

import "./SubcategoryForm.vue?vue&type=style&index=0&id=a6655238&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6655238"]])

export default __exports__